import { useMemo } from 'react';

export const useColumns = () =>
  useMemo(() => {
    return [
      {
        field: 'name',
        headerName: 'Name',
      },
      {
        field: 'date',
        headerName: 'Date',
      },
      {
        field: 'shift',
        headerName: 'Shift',
      },
      {
        field: 'type',
        headerName: 'Type',
      },
      {
        field: 'count',
        headerName: 'Count',
        align: 'right'
      },
    ];
  }, []);
